"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFullscreen = function IconFullscreen(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.47 42.215h.068c.753-.068 1.3-.684 1.232-1.437-.137-1.575 0-4.244 2.122-4.723 7.324-1.848 9.857-4.313 10.678-5.887.684.205 1.438.274 2.19.274h.274c.89 0 1.712-.137 2.533-.342.89 1.642 3.354 4.175 10.678 6.023 2.122.548 2.259 3.217 2.122 4.723-.068.753.48 1.37 1.232 1.438h.069c.684 0 1.232-.548 1.3-1.232.274-4.039-1.232-6.777-4.107-7.53-6.571-1.643-8.42-3.696-8.898-4.586.479-.342.89-.685 1.3-1.164 3.354-3.764 2.807-10.199 2.738-10.883-.342-6.777-4.997-9.173-8.898-9.173h-.411c-3.902 0-8.556 2.396-8.899 9.173-.068.616-.616 7.119 2.738 10.883.48.548.959.959 1.506 1.3-.137.206-.342.412-.616.685-1.026 1.027-3.285 2.464-8.282 3.697-2.875.753-4.381 3.49-4.107 7.46.205.754.753 1.301 1.437 1.301zM18.53 17.094v-.068c.274-6.23 4.86-6.709 6.23-6.709H25.17c1.37 0 5.955.48 6.23 6.709v.068c.204 1.643.136 6.366-2.123 8.899-1.027 1.163-2.464 1.78-4.312 1.78h-.069-.068c-1.848 0-3.286-.617-4.313-1.78-2.6-3.012-1.985-8.83-1.985-8.899z",
    fill: color,
    stroke: color,
    strokeWidth: 1.5
  }));
};

IconFullscreen.defaultProps = {
  color: 'black',
  size: 30
};
IconFullscreen.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconFullscreen;
exports.default = _default;